module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpifCuvwkAKYGIgEdBZA3tIEN+KJcxamhAukAHkAgWR1bCgaWCxMAcq+hQRA+QCGYx8fEDGzzXr4GoYkUMJYiRQ0f9Pn0ByYAZQ899r17E7CSgBlAYqAirFqppiTyM7CWIPchhg0cBdVw13CdxtQEEUQ8sFhFAM4OP7klsIdPf/129+HzzMoqwEDCJkbzAOg7QEEGAAqctPdxV8y/sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/delete3.png
// module id = 613
// module chunks = 1 6